"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "feilmeldingerForKortType", {
    enumerable: true,
    get: function() {
        return feilmeldingerForKortType;
    }
});
var _compact = /*#__PURE__*/ _interop_require_default(require("lodash/compact"));
var _get = /*#__PURE__*/ _interop_require_default(require("lodash/get"));
var _sjekker = require("../felt/sjekker");
var _utils = require("../utils");
var _types = require("../../../lib/visningsdefinisjon/types");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var redigerbareFelter = function(data, visningsdata, kortdefinisjon, kontroller) {
    return function(feltdefinisjon) {
        if (feltdefinisjon.beregnetFelt) {
            return !(feltdefinisjon.modus === "les") && !(0, _sjekker.feltSkalDeaktiveres)(feltdefinisjon, data, visningsdata, kontroller) && !(0, _sjekker.feltSkalSkjules)(feltdefinisjon, data, visningsdata, kontroller);
        }
        return !(feltdefinisjon.modus === "les") && !((0, _sjekker.feltSkalDeaktiveres)(feltdefinisjon, data, visningsdata, kontroller) && !(0, _sjekker.feltHarBeholdVerdi)(feltdefinisjon)) && !(0, _sjekker.feltSkalSkjules)(feltdefinisjon, data, visningsdata, kontroller) && !(0, _sjekker.skjulFeltMedReferansekobling)(feltdefinisjon, data, visningsdata, kortdefinisjon);
    };
};
var feilmeldingerForKortType = function(feilmeldingerForFelt) {
    return function() {
        var kortdefinisjon = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, data = arguments.length > 1 ? arguments[1] : void 0, valideringsstate = arguments.length > 2 ? arguments[2] : void 0, context = arguments.length > 3 ? arguments[3] : void 0, visningsdata = arguments.length > 4 ? arguments[4] : void 0, kontroller = arguments.length > 5 ? arguments[5] : void 0;
        var lagFeilmelding = function(feltId, felt, feltdata, feilmeldinger) {
            if ((0, _utils.erFeltMedEgenskaper)(felt)) {
                var allData = _object_spread({}, feltdata, feltdata[felt.referanse]);
                var egenskapsfelt = felt.barnliste || [];
                egenskapsfelt.filter(redigerbareFelter(allData, visningsdata, kortdefinisjon, kontroller)).forEach(function(egenskap) {
                    var egenskapSti = "".concat(felt.id, ".").concat(egenskap.id);
                    feilmeldinger = _object_spread({}, feilmeldinger, lagFeilmelding(egenskapSti, egenskap, (0, _get.default)(feltdata, felt.referanse), feilmeldinger));
                });
                var belopsfelt = felt.belopsfelt;
                var erBeloepsFeltRedigerbart = redigerbareFelter(allData, visningsdata, kortdefinisjon, kontroller)(belopsfelt);
                if (erBeloepsFeltRedigerbart) {
                    var referanse = (0, _compact.default)([
                        felt.referanse,
                        belopsfelt.referanse
                    ]).join(".");
                    feilmeldinger = _object_spread_props(_object_spread({}, feilmeldinger), _define_property({}, feltId, feilmeldingerForFelt(belopsfelt, (0, _get.default)(feltdata, referanse), valideringsstate, context, visningsdata)));
                }
                return feilmeldinger;
            }
            return _object_spread_props(_object_spread({}, feilmeldinger), _define_property({}, feltId, feilmeldingerForFelt(felt, (0, _get.default)(feltdata, felt.referanse), valideringsstate, _object_spread({}, context, feltdata), visningsdata)));
        };
        var getFeilmeldingerFraRepeterendefelt = function(barn) {
            var gjeldendeForekomst = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : data;
            var feilmeldinger = {};
            var underforekomster = (0, _get.default)(gjeldendeForekomst, barn.referanse, []);
            underforekomster.forEach(function(underforekomst) {
                var allData = _object_spread({}, gjeldendeForekomst, underforekomst);
                var feltSti = function(felt) {
                    return (0, _compact.default)([
                        barn.id,
                        (0, _utils.getFeltId)(felt),
                        underforekomst.id
                    ]).join(".");
                };
                var synligeBarn = function() {
                    var barnliste = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                    return barnliste.filter(redigerbareFelter(allData, visningsdata, kortdefinisjon, kontroller));
                };
                feilmeldinger = _object_spread_props(_object_spread({}, feilmeldinger), _define_property({}, "".concat(barn.id, ".").concat(underforekomst.id), feilmeldingerForFelt(barn, underforekomst, valideringsstate, _object_spread({}, context, allData), visningsdata)));
                var lagFeilmeldingIRepFelt = function(felt) {
                    if ((0, _types.erFeltgruppe)(felt)) {
                        feilmeldinger = lagFeilmelding(feltSti(felt), felt, allData, feilmeldinger);
                        synligeBarn(felt.barnliste).forEach(lagFeilmeldingIRepFelt);
                    } else if ((0, _types.erDynamiskGruppe)(felt) && Array.isArray((0, _get.default)(underforekomst, felt.referanse))) {
                        feilmeldinger = _object_spread({}, feilmeldinger, getFeilmeldingerFraDynamiskGruppe(felt, allData, feltSti));
                    } else if ((0, _types.erRepeterendeFelt)(felt)) {
                        var feltSti1 = (0, _compact.default)([
                            felt.id,
                            underforekomst.id
                        ]).join(".");
                        feilmeldinger = lagFeilmelding(feltSti1, felt, allData, feilmeldinger);
                        if (Array.isArray((0, _get.default)(underforekomst, felt.referanse))) {
                            feilmeldinger = _object_spread({}, feilmeldinger, getFeilmeldingerFraRepeterendefelt(felt, allData));
                        }
                    } else {
                        feilmeldinger = lagFeilmelding(feltSti(felt), felt, allData, feilmeldinger);
                    }
                };
                synligeBarn(barn.barnliste).forEach(lagFeilmeldingIRepFelt);
            });
            return feilmeldinger;
        };
        var getFeilmeldingerFraDynamiskGruppe = function(dynamiskgruppe) {
            var dynamiskgruppeData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : data, lagFeltId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(felt) {
                return (0, _utils.getFeltId)(felt);
            };
            var feilmeldinger = {};
            (0, _get.default)(dynamiskgruppeData, dynamiskgruppe.referanse, []).forEach(function(feltdata) {
                var barnliste = dynamiskgruppe.barnliste || [];
                barnliste.filter(function(dynamiskfelt) {
                    return dynamiskfelt.datatype === feltdata.behandlingsart;
                }).filter(redigerbareFelter(_object_spread({}, dynamiskgruppeData, feltdata), visningsdata, kortdefinisjon, kontroller)).forEach(function(dynamiskfelt) {
                    var felter = dynamiskfelt.barnliste || [];
                    felter.filter(redigerbareFelter(_object_spread({}, dynamiskgruppeData, feltdata), visningsdata, kortdefinisjon, kontroller)).forEach(function(felt) {
                        feilmeldinger = lagFeilmelding(lagFeltId(felt), felt, feltdata, feilmeldinger);
                    });
                });
            });
            return feilmeldinger;
        };
        var filtrerRedigerbareFelter = redigerbareFelter(data, visningsdata, kortdefinisjon, kontroller);
        return _object_spread(_define_property({}, kortdefinisjon.id, feilmeldingerForFelt(kortdefinisjon, undefined, valideringsstate, context, visningsdata)), (kortdefinisjon.barnliste || []).filter(filtrerRedigerbareFelter).reduce(function(acc, barn) {
            var feilmeldinger = acc;
            if ((0, _types.erFeltEllerFeltMedEgenskaper)(barn)) {
                feilmeldinger = lagFeilmelding((0, _utils.getFeltId)(barn), barn, data, feilmeldinger);
            } else if ((0, _types.erRepeterendeFelt)(barn)) {
                feilmeldinger = lagFeilmelding((0, _utils.getFeltId)(barn), barn, data, feilmeldinger);
                if (Array.isArray((0, _get.default)(data, barn.referanse))) {
                    feilmeldinger = _object_spread({}, feilmeldinger, getFeilmeldingerFraRepeterendefelt(barn));
                }
            } else if ((0, _types.erDynamiskGruppe)(barn) && Array.isArray((0, _get.default)(data, barn.referanse))) {
                feilmeldinger = _object_spread(_object_spread_props(_object_spread({}, feilmeldinger), _define_property({}, barn.id, feilmeldingerForFelt(barn, undefined, valideringsstate, context, visningsdata))), getFeilmeldingerFraDynamiskGruppe(barn));
            } else if ((0, _types.erFeltgruppe)(barn)) {
                feilmeldinger = _object_spread({}, feilmeldinger, feilmeldingerForKortType(feilmeldingerForFelt)(barn, data, valideringsstate, context, visningsdata, kontroller));
            }
            return feilmeldinger;
        }, {}));
    };
};
